<template>
  <div class="contents">
    <common-header
      :menu="headerMenu"
      :mute="mute"
      :camera-mode="currentCameraMode"
      @button-clicked="onButtonClicked"
      @camera-mode-change="onCameraChange" />
    <settings-modal ref="settings" :settings="settings"
                    :display-value="displayValue"
                    @camera-mode-change="onCameraChange"
                    @settings-change="onSettingChange" />
    <common-display :debug-meg="debugMeg" :navigations="navigations" />
    <side-menu v-show="canShowSideMenu" :menu="sideMenu"
               @button-clicked="onButtonClicked" />
    <section v-show="canShowHeaderMenu" class="score-boards">
      <score-board title="回数" :value="score" unit="回" :min-length="4" class="score-borad" />
    </section>
    <title-label :title="title"/>
    <common-modal ref="modal" :steps="steps"/>
    <fill-camera-layout
      @camera-required="start"
      :device-state="deviceState"
      :camera-state="manager ? manager.state : null"/>
    <common-footer v-show="canShowFooterMenu" :menu="footerMenu" />
  </div>
</template>

<script>
import "@pqina/flip/dist/flip.min.css";
import SettingButton from "../SettingButton";
import Separator from "../Separator";
import CommonHeader from "../CommonHeader";
import {CAMERA_MODE} from '../common/CameraRenderer'
import {CommonMixin} from '../common/CommonMixin'
import FillCameraLayout from "../FillCameraLayout";
import CommonDisplay from "../CommonDisplay";
import CommonFooter from "../CommonFooter";
import ScoreBoard from "../common/ScoreBoard";
import SettingsModal from "../common/SettingsModal";
import CommonModal from "../common/CommonModal";
import SideMenu from "../SideMenu";
import {DumbbellCurl} from "../game/DumbbellCurl";
import TitleLabel from "../common/TitleLabel";

export default {
  name: 'DumbbellCurl',
  mixins: [CommonMixin],
  components: {TitleLabel, SideMenu, CommonModal, SettingsModal, ScoreBoard, CommonFooter, CommonDisplay, FillCameraLayout, CommonHeader, Separator, SettingButton},
  data () {
    return {
      showScore: false,
      defaultCameraMode: CAMERA_MODE.FIGURE,
      headerMenu: Object.assign({}, this.defaultHeaderMenu(), {  }),
      sideMenu: Object.assign({}, this.defaultSideMenu(), {}),
      footerMenu: Object.assign({}, this.defaultFooterMenu(), {}),
      settings: [
        { key: 'detectThreshold', type: 'range', label: '検出閾値(相対)', default: 0.8, step:0.01, min:0.5, max:0.99 },
        { key: 'resetThreshold', type: 'range', label: '戻した姿勢検出閾値(相対)', default: 0.5, step:0.01, min:1.01, max:0.99 },
        { key: 'fistType', type: 'select', label: '判定する腕', default: 'right', options: [
            { value: 'right', label: '右腕' },
            { value: 'left', label: '左腕' },
          ] },
      ],
      steps: [
        'カメラに腕を映します',
        '肩の位置まで腕を上げ下げします',
      ],
    }
  },
  computed: {
    title() {
      return 'ダンベル(カール)'
    },
    desc() {
      return '毎日の筋トレをWebカメラで自動計測するツール'
    },
  },
  methods: {
    createContents() {
      return new DumbbellCurl();
    },
    setScores() {
      this.score = Math.round(this.manager.game.score)
      this.navigations = this.manager.game.navigations
      this.debugMeg = this.manager.game.debug
    }
  }
}
</script>

<style scoped>
.score-borad {
  margin: 0 auto;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/contents-page/DumbbellCurl.vue